import { Page } from '@/shared/ui/Page';
import { CreateWizard } from '@/features/create-subscription/CreateWizard';

export function CreatePage() {
  return (
    <Page withDock={false} className="overflow-hidden">
      <CreateWizard />
    </Page>
  );
}
